module.exports = __webpack_public_path__ + "img/apvertise_loader.500af6e2.gif";